<template>
  <el-select class="td_select"
             v-model="values"
             default-first-option
             filterable
             remote
             reserve-keyword
             placeholder="请输入关键词"
             :clearable="clearable"
             :disabled="disabled"
             :remote-method="remoteMethod"
             :loading="loading">
    <el-option
      class="td_option"
      v-for="(item, index) in options"
      :key="index"
      :label="item.logisticCode+ '  ' +item.logisticName"
      :value="item.logisticName"
      @click.native="handleSelect(item)">
<!--      <span>{{item.logisticName}}</span>-->
      <span style="float: left;">{{ item.logisticCode }}</span>
      <span style="float: left; color: #8492a6; font-size: 13px; margin-left: 10px;">{{ item.logisticName }}</span>
    </el-option>
  </el-select>
</template>
<script>

import { validatenull } from '@/tdcommon/validate'
import { getlogisticAll } from '@/api/basic/logistic'

export default {
  name: 'd2-container-bussup-all',
  data () {
    return {
      values: this.value,
      options: [],
      loading: false
    }
  },
  props: {
    value: {
      type: String,
      default: () => ''
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    remoteMethod (query) {
      this.loading = true
      if (query === null) {
        this.loading = false
        return
      }
      getlogisticAll(query).then(response => {
        this.loading = false
        if (response.code === 0) {
          this.options = response.data
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleSelect (val) {
      this.$emit('change', val)
    }
  },
  watch: {
    values: function (val, oldVal) {
      this.$emit('input', val.toString())
    },
    value: function (val, oldVal) {
      this.remoteMethod(val)
      this.values = val
      if (validatenull(val)) {
        this.$emit('change', '')
      }
    }
  },
  mounted () {
    this.remoteMethod(this.value)
  }
}
</script>

<style lang="scss" scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-bussup-all/index.vue"
}
</vue-filename-injector>
